"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseOfferStatus = void 0;
var FundraiseOfferStatus;
(function (FundraiseOfferStatus) {
    FundraiseOfferStatus["PAID"] = "paid";
    FundraiseOfferStatus["UNPAID"] = "unpaid";
    FundraiseOfferStatus["PENDING_RECONCILIATION"] = "pending_reconciliation";
    FundraiseOfferStatus["CANCELLED"] = "cancelled";
})(FundraiseOfferStatus || (exports.FundraiseOfferStatus = FundraiseOfferStatus = {}));
//# sourceMappingURL=IFundraiseOffer.js.map